<script lang="ts">
import { Bar, Line } from "vue-chartjs";
import { Component, Vue, Prop } from "vue-property-decorator";
import { getMonths } from "@/Utilities/dateUtility";
// @ts-ignore
@Component({
  extends: Line, // this is important to add the functionality to your component
})
export default class CommitChart extends Vue<Line> {
  @Prop({ default: null }) currentYear: Array<number>;
  @Prop({ default: null }) previousYear: Array<number>;
  @Prop({ default: null }) year: number;

  public language: any;
  public gradient: any | null;
  public gradient2: any | null;
  public option: any = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
          gridLines: {
            display: false,
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            display: false,
          },
        },
      ],
    },
    legend: {
      display: true,
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  public mounted(): void {
    this.language = [
      {
        month: getMonths(),
      },
      {
        earnedThisYear: this.$t(this.$ts.commitChart.currentYear, {
          year: this.year,
        }),
      },
      {
        earnedLastYear: this.$t(this.$ts.commitChart.previousYear, {
          year: this.year - 1,
        }),
      },
    ];

    // Overwriting base render method with actual data.
    const canvas: any = this.$refs.canvas;
    const self = this;

    this.gradient = canvas.getContext("2d").createLinearGradient(0, 0, 0, 450);
    this.gradient2 = canvas.getContext("2d").createLinearGradient(0, 0, 0, 450);

    this.gradient.addColorStop(0, "rgba(135, 106, 255, 0.8)");
    this.gradient.addColorStop(0.5, "rgba(135, 106, 255, 0.5)");
    this.gradient.addColorStop(1, "rgba(135, 106, 255, 0)");

    this.gradient2.addColorStop(0, "rgba(86, 220, 182, 0.5)");
    this.gradient2.addColorStop(0.5, "rgba(86, 220, 182, 0.5)");
    this.gradient2.addColorStop(1, "rgba(86, 220, 182, 0.5)");

    const options = {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              padding: 20,
              callback: function (value: number) {
                return self.$t(self.$ts.currency) + " " + value.toLocaleString();
              },
            },
            gridLines: {
              display: true,
              color: "rgba(200, 200, 200, 0.15)",
              zeroLineColor: "rgba(200, 200, 200, 0.25)",
              drawTicks: false,
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              padding: 20,
            },
            gridLines: {
              display: false,
            },
          },
        ],
      },
      legend: {
        display: true,
        padding: 30,
      },
      layout: {
        padding: {
          left: 20,
          right: 20,
          top: 20,
          bottom: 20,
        },
      },
      responsive: true,
      maintainAspectRatio: false,
      tooltips: {
        callbacks: {
          label: function (tooltipItem: any, data: any) {
            const dataset = data.datasets[tooltipItem.datasetIndex];
            const value = dataset.data[tooltipItem.index];
            return dataset.label + ": " + self.$t(self.$ts.currency) + " " + value.toLocaleString();
          },
        },
      },
    };

    this.renderChart(
      {
        labels: this.language[0].month,
        datasets: [
          {
            label: this.$t(this.$ts.commitChart.currentYear, {
              year: this.year,
            }).toString(),
            borderColor: "#876AFF",
            pointBackgroundColor: "#876AFF",
            borderWidth: 1,
            pointBorderColor: "#876AFF",
            backgroundColor: this.gradient,

            data: this.currentYear,
          },
          {
            label: this.$t(this.$ts.commitChart.previousYear, {
              year: this.year - 1,
            }).toString(),
            borderColor: "#56dcb6",
            pointBackgroundColor: "#56dcb6",
            borderWidth: 1,
            pointBorderColor: "#56dcb6",
            backgroundColor: this.gradient2,

            data: this.previousYear,
          },
        ],
      },
      options
    );
  }
}
</script>

<style>
.Chart {
  background: #212733;
  border-radius: 15px;
  box-shadow: 0px 2px 15px rgba(25, 25, 25, 0.27);
  margin: 25px 0;
}

.Chart h2 {
  margin-top: 0;
  padding: 15px 0;
  color: rgba(255, 0, 0, 0.5);
  border-bottom: 1px solid #323d54;
}
</style>
